import {ADD_ITEM_CART, DELETE_ITEM_CART, CLEAN_CART, ADD_ITEM_CART_SUCCESS} from '../constants';
import { userConstants } from '../constants/user.constants.js';

const initialState = {};

export const cart = (state = initialState, action) => {
    switch (action.type) {
        case ADD_ITEM_CART:
            return {
                ...state,
                cart: action.payload
            };
        case DELETE_ITEM_CART:
            return {
                ...state,
                cart: state.cart.filter(c => c.key !== action.payload )
            };
        case ADD_ITEM_CART_SUCCESS:
            return {
                ...state,
                cart: action.payload
            }
        case CLEAN_CART || userConstants.LOGOUT:
            return initialState;
        default:
            return state
    }
};
